

import React, { Component } from 'react';
import Spinner from "react-spinners/RingLoader";
import {Card, Row} from 'reactstrap'

class Splash extends Component 
{
    render()
    {
        return  <div style={
                                {
                                    position: 'absolute', left: '50%', top: '50%',
                                    transform: 'translate(-50%, -50%)'
                                }
                            }
                >
                    
                    <Card style={{borderRadius: 20, textAlign:'center', paddingLeft:'100px', paddingRight:'100px', paddingTop:'50px', paddingBottom:'50px'}}>
                        <Row className="justify-content-center">
                            <Spinner color={`var(--spinner-color)`} size={50} radius={100} />
                        </Row>

                        <Row className="justify-content-center" style={{marginTop:'20px'}}>
                            <h4>Please Wait</h4>
                        </Row>
                    </Card>
                </div>
    }
}

export default Splash;